import styled from 'styled-components';
import { ActionMenu } from 'ui/actionMenu';
import { ButtonOption, MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { IconButton, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Close16 } from 'ui/icons';

type CustomInsightRemovalMenuProps = {
  options: ButtonOption[];
};

const StyledIconButton = styled(IconButton)`
  ${({ theme }) => theme.elevations.buttonShadow};
`;

export const CustomInsightRemovalMenu = ({ options }: CustomInsightRemovalMenuProps) => {
  return (
    <ActionMenu options={options} align={MENU_ALIGNMENTS.RIGHT}>
      <StyledIconButton size={BUTTON_SIZES.SMALL} variant={BUTTON_VARIANTS.SECONDARY}>
        <Close16 />
      </StyledIconButton>
    </ActionMenu>
  );
};
